import { makeStyles } from '@rneui/themed'
import parse, { domToReact } from 'html-react-parser'
import React from 'react'
import { StyleProp, Text, TextStyle, View } from 'react-native'

export const HTMLText = ({
  text,
  style,
}: {
  text: string
  style: StyleProp<TextStyle>
}) => {
  const styles = useStyles()

  const renderNode = (node, parentStyles = {}, indentLevel = 0) => {
    if (node.type === 'tag') {
      let combinedStyles = { ...parentStyles }

      if (node.name === 'i') {
        combinedStyles = { ...combinedStyles, fontStyle: 'italic' }
      }
      if (node.name === 'b') {
        combinedStyles = { ...combinedStyles, fontWeight: 'bold' }
      }

      const children = domToReact(node.children, {
        replace: childNode =>
          renderNode(
            childNode,
            combinedStyles,
            node.name === 'ul' ? indentLevel + 1 : indentLevel
          ),
      })

      if (node.name === 'li') {
        return (
          <View
            key={node.key}
            style={[
              styles.listItemContainer,
              {
                marginLeft: indentLevel * 10,
              },
            ]}
          >
            <Text style={[styles.bulletIconText, style]}>•</Text>
            <Text style={[combinedStyles, style, styles.listItemText]}>
              {children}
            </Text>
          </View>
        )
      }

      if (node.name === 'ul') {
        return (
          <View key={node.key} style={{ marginLeft: indentLevel * 10 }}>
            {children}
          </View>
        )
      }

      if (node.name === 'br') {
        return (
          <Text key={node.key} style={styles.lineBreak}>
            {'\n'}
          </Text>
        )
      }

      return (
        <Text key={node.key} style={[combinedStyles, style]}>
          {children}
        </Text>
      )
    }

    if (node.type === 'text') {
      return (
        <Text key={node.key} style={[parentStyles, style]}>
          {node.data}
        </Text>
      )
    }

    return null
  }

  const parsedText = parse(text, { replace: renderNode })

  return <View style={styles.htmlTextContainer}>{parsedText}</View>
}

const useStyles = makeStyles({
  htmlTextContainer: { flexDirection: 'column' },
  listItemContainer: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  bulletIconText: { marginRight: 5 },
  listItemText: {
    flex: 1,
  },
  lineBreak: { height: 10 },
})
